<template>
  <div class="trolley max-width">
    <!-- 空 -->
    <div v-if="tro_list && tro_list.length < 1" class="tro_null">
      <img class="tro_null_img" src="@/assets/icon/trolley_null.png" />
      <div class="tro_null_font fontcolor-18-shallow">空空如也</div>
    </div>

    <div v-if="tro_list && tro_list.length > 0" class="tro_model normal-width">
      <!-- 标题 -->
      <div class="tro_model_line tro_model_title theme-font-body-03">
        <div class="tro_model_li_filename">上传文件名称</div>
        <!-- <div class='tro_model_li_product'>产品名称</div> -->
        <div class="tro_model_li_num">款数</div>
        <div class="tro_model_li_price">价格</div>
        <div class="tro_model_li_opera">操作</div>
      </div>

      <!-- 列表 -->
      <div
        v-for="(item, index) in tro_list"
        :key="item.id"
        class="tro_model_line theme-font-body-03"
      >
        <div class="tro_model_li_filename">
          <div class="tro_model_li_finame_line">
            {{
              item.uploadedfilenameold_modify
                ? item.uploadedfilenameold_modify
                : item.uploadedfilenameold
            }}
          </div>
          <!-- 收货地址 -->
          <div class="tro_model_li_finame_line">
            {{
              item.g_address.email
                ? item.g_address.email +
                  ("-" +
                    item.g_address.rsrvstr2 +
                    "-" +
                    item.g_address.rsrvstr1 +
                    "-" +
                    item.g_address.rsrvstr4 +
                    "-" +
                    item.g_address.address)
                : item.g_address.rsrvstr3 +
                  ("-" +
                    item.g_address.rsrvstr2 +
                    "-" +
                    item.g_address.rsrvstr1 +
                    "-" +
                    item.g_address.rsrvstr4 +
                    "-" +
                    item.g_address.address)
            }}
          </div>
          <!-- 备注 -->
          <div class="tro_model_li_finame_line">
            {{ item.remark ? item.remark : "" }}
          </div>
        </div>
        <!-- <div class='tro_model_li_product'>
				<div class='tro_model_li_prod_name theme-font-title-bo-01'>{{item.productName}}</div>
				<div class='tro_model_li_prod_prompt'>{{item.offerInfoString}}</div>
			 </div> -->
        <div class="tro_model_li_num">
          {{ item.kuanshu ? item.kuanshu : "1" }}
        </div>
        <div class="tro_model_li_price theme-fontcolor-bo-01">
          ￥{{ item.offerInfoPrice
          }}<span v-if="item.kuaidifei !== 0"
            ><span v-if="item.kuaidifei > 0">+</span></span
          >{{ item.kuaidifei > 0 ? item.kuaidifei : "" }}
        </div>
        <div class="tro_model_li_opera">
          <!-- <div class='theme-button-01' :data-index='index' @click='func_delete'>删除</div> -->
          <img
            class="tro_model_li_ope_view no-copy"
            title="删除"
            :data-index="index"
            data-opera="delete"
            src="@/assets/icon/trolley_delete.png"
            @click="func_opera"
          />
          <!-- <img class='tro_model_li_ope_view no-copy' 
             title='更改地址' 
             :data-index='index' 
              data-opera='address' 
             src='@/assets/icon/trolley_address.png' 
             @click='func_opera' 
             /> -->
          <img
            class="tro_model_li_ope_view no-copy"
            title="修改备注"
            :data-index="index"
            data-opera="remark"
            src="@/assets/icon/trolley_remark.png"
            @click="func_opera"
          />
        </div>
      </div>

      <!-- 统计、按钮 -->
      <div class="tro_model_bottom">
        <div class="tro_model_bot_view theme-font-body-03">
          订单产品数量: {{ tro_list.length }}
        </div>
        <div class="tro_model_bot_view theme-font-body-03">
          总价:<span class="tro_model_bot_vi_price">￥{{ total_price }}</span>
        </div>
        <!-- <div class='tro_model_bot_btn tro_model_bot_btn_sellt' @click='func_settlement'>去结算</div>
			<div class='tro_model_bot_btn tro_model_bot_btn_theme' @click='func_baojia'>继续报价</div> -->
      </div>

      <!-- 下单配置 -->
      <div class="tro_model_config">
        <!-- 配送方式 -->
        <div class="tro_model_cfg_wuliu">
          <!-- <div class='tro_model_cfg_view_title fontweight-bo fontcolor-16'>配送方式</div>
        <div class='tro_model_cfg_wl_model'>
          <template v-for='(item,index) in wuliu'>
            <div :key='item.id' 
                 :class="{'tro_model_cfg_wl_mod_view font-14 color-prompt no-newline':true, 'color border-color':item.choose, 'tro_model_cfg_wl_mod_vi_border':!item.choose}" 
                 :data-index='index' 
                 @click='func_wuliu'>
                 <img class='tro_model_cfg_wl_mod_vi_icon' :src='item.choose ? item.icon[1] : item.icon[0]' />
                 <div>{{item.name}}</div>
            </div>
          </template>
          <div>{{userDeposit.loginip ? userDeposit.loginip : ''}}</div>
        </div> -->
        </div>
        <!-- 支付方式 -->
        <div class="tro_model_cfg_payment">
          <div class="tro_model_cfg_view_title fontweight-bo fontcolor-16">
            支付方式
          </div>
          <div class="tro_model_cfg_py_model">
            <template v-for="(item, index) in payway">
              <div
                :key="item.id"
                :class="{
                  'tro_model_cfg_wl_mod_view font-14 color-prompt no-newline': true,
                  'color border-color': item.choose,
                  tro_model_cfg_wl_mod_vi_border: !item.choose,
                }"
                :data-index="index"
                @click="func_payway"
              >
                <img
                  class="tro_model_cfg_wl_mod_vi_icon"
                  :src="item.choose ? item.icon[1] : item.icon[0]"
                />
                <div>{{ item.name }}</div>
              </div>
            </template>
            <div class="fontcolor-18-shallow">
              预存款：￥{{ userDeposit.moneys }}
            </div>
          </div>
        </div>
        <!-- 下单必读 -->
        <div class="tro_model_cfg_submit">
          <div class="tro_model_cfg_view_title fontweight-bo fontcolor-16">
            确认下单
          </div>
          <div class="tro_model_cfg_sub_model">
            <div class="font-14 color">
              提交订单前,
              请您确认订单信息无误。下单人承诺：所提供资料（含知识产权）真实、合法，由此引发的所有问题由下单人负责。此订单等同于印刷委托书
            </div>
            <div class="tro_model_cfg_sub_mod_btn no-copy">
              <div
                class="tro_model_cfg_sub_mod_btn_view bgcolor-gradient-right"
                @click="func_submit"
              >
                提交订单
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-addressList ref="vadl"></v-addressList>
    <v-addressCreate ref="vadc"></v-addressCreate>
  </div>
</template>

<script>
// icons
import pwyck from "@/assets/icon/payway_yucunkuan.png";
import pwycked from "@/assets/icon/payway_yucunkuan_ed.png";
import pwzx from "@/assets/icon/payway_zaixian.png";
import pwzxed from "@/assets/icon/payway_zaixian_ed.png";
import lwsm from "@/assets/icon/logisticsway_shangmen.png";
import lwsmed from "@/assets/icon/logisticsway_shangmen_ed.png";
import lwhy from "@/assets/icon/logisticsway_huoyun.png";
import lwhyed from "@/assets/icon/logisticsway_huoyun_ed.png";
import lwkd from "@/assets/icon/logisticsway_kuaidi.png";
import lwkded from "@/assets/icon/logisticsway_kuaidi_ed.png";
import lwshsm from "@/assets/icon/logisticsway_shsm.png";
import lwshsmed from "@/assets/icon/logisticsway_shsm_ed.png";
import opmr from "@/assets/icon/opera_moren.png";
import opmred from "@/assets/icon/opera_moren_ed.png";
import opbj from "@/assets/icon/opera_bianji.png";
import opbjed from "@/assets/icon/opera_bianji_ed.png";
import opqt from "@/assets/icon/opera_qita.png";
import opqted from "@/assets/icon/opera_qita_ed.png";
import opxz from "@/assets/icon/opera_xinzeng.png";
import opxzed from "@/assets/icon/opera_xinzeng_ed.png";

import addressList from "@/components/address/addressList";
import addressCreate from "@/components/address/addressCreate";
import {
  req_userDeposit,
  req_userAddressList,
  req_userAddressCreate,
} from "@/services/user";
import { req_bjlogInfo, req_orderCreate } from "@/services/order";

export default {
  name: "trolley",
  components: {
    "v-addressList": addressList,
    "v-addressCreate": addressCreate,
  },
  data() {
    return {
      tro_list: [],
      total_price: 0,
      wuliu: [
        //出货方式
        {
          id: "lwsm",
          name: "自取",
          icon: [lwsm, lwsmed],
          value: "0",
          choose: true,
        },
        {
          id: "lwkd",
          name: "快递",
          icon: [lwhy, lwhyed],
          value: "2",
          choose: false,
        },
        {
          id: "lwwl",
          name: "物流送货上门",
          icon: [lwhy, lwhyed],
          value: "3",
          choose: false,
        },
      ],
      payway: [
        //支付方式
        {
          id: "pwyck",
          name: "预存款扣费",
          icon: [pwyck, pwycked],
          value: "0",
          choose: true,
        },
        {
          id: "pwzx",
          name: "在线支付",
          icon: [pwzx, pwzxed],
          value: "1",
          choose: false,
        },
      ],
      userinfo: false, //用户信息
      userDeposit: false, //用户信用额度
      address_list: [], //用户所有地址列表
      isRoute: false,
    };
  },
  methods: {
    // 去结算
    func_settlement() {
      this.$router.push({
        name: "settlement",
      });
    },
    func_baojia() {
      this.$router.push({
        name: "order",
      });
    },
    // 产品操作按钮
    func_opera(event) {
      const index = event.currentTarget.dataset.index;
      const opera = event.currentTarget.dataset.opera;
      switch (opera) {
        // 删除
        case "delete": {
          this.$parent.confirmChange(
            "information",
            "确认从购物车中删除该条商品？",
            () => {
              setTimeout(() => {
                let temp = this.STORAGE.get("g_trollerList");
                temp.splice(index, 1);
                if (temp.length > 0) {
                  this.STORAGE.set("g_trollerList", temp);
                } else {
                  this.STORAGE.remove("g_trollerList");
                }
                this.$parent.func_tabbar_trolley();
                this.func_init();
              }, 300);
            },
            () => {},
            { yes: "确定", no: "取消" }
          );
          break;
        }
        // 设置地址
        case "address": {
          this.$refs.vadl.vadl_Change(this.address_list, index);
          break;
        }
        // 设置备注
        case "remark": {
          let remark = prompt(
            "请输入备注：",
            this.tro_list[index]["remark"] ? this.tro_list[index]["remark"] : ""
          );
          if (remark !== null && remark !== this.tro_list[index]["remark"]) {
            this.tro_list[index]["remark"] = remark;
            this.STORAGE.set("g_trollerList", this.tro_list);
            this.func_init();
          }
          break;
        }
      }
    },
    // 切换配送方式
    func_wuliu(event) {
      const index = event.currentTarget.dataset.index;
      if (!this.wuliu[index]["choose"]) {
        for (let i in this.wuliu) {
          if (this.wuliu[i]["choose"]) {
            this.wuliu[i]["choose"] = false;
            this.wuliu[index]["choose"] = true;
            break;
          }
        }
      }
    },
    // 切换支付方式
    func_payway(event) {
      const index = event.currentTarget.dataset.index;
      if (!this.payway[index]["choose"]) {
        for (let i in this.payway) {
          if (this.payway[i]["choose"]) {
            this.payway[i]["choose"] = false;
            this.payway[index]["choose"] = true;
            break;
          }
        }
      }
    },
    // 地址列表回调-切换地址
    async vadl_callback(index, modifyIndex) {
      // this.tro_list[modifyIndex]['g_address'] = this.address_list[index];
      if (this.address_list[index]) {
        // 把切换的新地址存到购物车产品缓存中
        let temp = this.STORAGE.get("g_trollerList");
        temp[modifyIndex]["g_address"] = this.address_list[index];
        this.STORAGE.set("g_trollerList", temp);
        // 重新获取购物车产品订单信息
        this.$parent.loadingChange(true);
        await this.func_trolleyList();
        this.$parent.loadingChange(false);
      }
    },
    // 地址列表回调-新增地址
    vadl_callback_create(index) {
      this.$refs.vadc.vadc_Change(index);
    },
    // 新增地址组件回调-新增地址
    async func_createAddress(params, index) {
      this.$parent.loadingChange(true, "正在创建地址....");
      const result = await req_userAddressCreate(
        this.userinfo["userid"],
        params["Address"],
        params["Attn"],
        params["Company"],
        params["Mobile"],
        params["province"],
        params["city"],
        params["area"]
      );
      this.$parent.loadingChange(false);
      if (result.success) {
        this.$parent.msgChange("success", "新增地址成功", result.msg);
        this.func_userAddressList(index);
      } else {
        this.$parent.msgChange("fail", "新增地址失败", result.msg);
      }
    },
    // 获取购物车列表
    func_trolleyList() {
      return new Promise(async (resolve, reject) => {
        const result = this.STORAGE.get("g_trollerList");
        if (result && result.length >= 1) {
          this.tro_list = result;
          this.total_price = 0;
          let failArr = []; // 获取bjlog异常的订单
          for (let i in this.tro_list) {
            // 1) 请求bjlog信息-非标产品除外
            const bid = this.tro_list[i]["bid"];
            if (bid && bid !== "0") {
              const bjlog = await req_bjlogInfo(bid);
              if (bjlog.success) {
                this.tro_list[i]["g_bjlog"] = bjlog.data;
              } else {
                failArr.push(this.tro_list[i]);
              }
            }
            // 2) 计算订单金额(非标产品用输入金额, 其他产品用bjlog金额)
            if (this.tro_list[i]["fbPrice"]) {
              this.total_price = (
                parseFloat(this.total_price) +
                parseFloat(this.tro_list[i]["fbPrice"])
              ).toFixed(2);
            } else {
              this.total_price =
                parseFloat(this.total_price) +
                parseFloat(this.tro_list[i].offerInfoPrice) +
                parseFloat(this.tro_list[i].kuaidifei);
            }
          }
          if (failArr.length > 0) {
            this.$parent.confirmChange(
              "warning",
              "购物车订单信息异常",
              () => {},
              () => {},
              { yes: "知道了", no: "" }
            );
          }
        } else {
          this.tro_list = [];
          this.total_price = 0;
        }
        resolve(true);
      });
    },
    // 获取预存款、信用额度
    func_userDeposit() {
      return new Promise(async (resolve, reject) => {
        const result = await req_userDeposit(this.userinfo["userid"]);
        if (result.success) {
          this.userDeposit = result.data;
        } else {
        }
        resolve(true);
      });
    },
    // 获取更新用户地址列表
    func_userAddressList(modifyIndex) {
      return new Promise(async (resolve, reject) => {
        const result = await req_userAddressList(this.userinfo["userid"]);
        if (result.success && result.data.length > 0) {
          this.address_list = result.data;

          if (modifyIndex) {
            // modifyIndex存在时, 把新地址替换到购物车的modifyIndex产品
            // 1) 确认新地址
            let isNewIndex = 0;
            for (let i = 1; i < this.address_list.length; i += 1) {
              if (
                parseInt(this.address_list[i]["id"]) >
                parseInt(this.address_list[isNewIndex]["id"])
              ) {
                isNewIndex = parseInt(i);
              }
            }
            // 2) 替换新地址到购物车产品
            let temp = this.STORAGE.get("g_trollerList");
            temp[modifyIndex]["g_address"] = this.address_list[isNewIndex];
            this.STORAGE.set("g_trollerList", temp);
            // 3) 重新获取购物车产品订单信息
            this.$parent.loadingChange(true);
            await this.func_trolleyList();
            this.$parent.loadingChange(false);
          }
        }
        resolve(true);
        // this.$parent.loadingChange(false);
      });
    },
    // 提交订单
    async func_submit() {
      // 物流方式
      let wuliu = false;
      for (let i in this.wuliu) {
        if (this.wuliu[i]["choose"]) {
          wuliu = this.wuliu[i]["value"];
          break;
        }
      }
      // 支付方式
      let payment = false;
      for (let i in this.payway) {
        if (this.payway[i]["choose"]) {
          payment = this.payway[i]["value"];
          break;
        }
      }
      if (payment === "0") {
        /* 预存款扣费 */
        const canPay =
          parseInt(this.userDeposit.quota) + parseInt(this.userDeposit.moneys);
        const finalSumPrice = parseFloat(this.total_price);
        if (canPay >= finalSumPrice) {
          //循环订单列表-提交订单
          let failArr = []; //提交失败的订单
          this.$parent.loadingChange(true, "提交订单中");
          for (let i in this.tro_list) {
            let gRemark = this.tro_list[i].remark
              ? this.tro_list[i].remark
              : "";
            let strAddress = "";
            if (this.tro_list[i]["g_address"]) {
              if (
                this.tro_list[i]["g_address"].rsrvstr3 === "快递" ||
                this.tro_list[i]["g_address"].rsrvstr3.indexOf("物流") >= 0 ||
                this.tro_list[i]["g_address"].rsrvstr3 === "代发快递" ||
                this.tro_list[i]["g_address"].rsrvstr3 === "代发物流"
              ) {
                strAddress += this.tro_list[i]["g_address"].province
                  ? this.tro_list[i]["g_address"].province + ","
                  : "";
                strAddress += this.tro_list[i]["g_address"].city
                  ? this.tro_list[i]["g_address"].city + ","
                  : "";
                strAddress += this.tro_list[i]["g_address"].area
                  ? this.tro_list[i]["g_address"].area + ","
                  : "";
                strAddress += this.tro_list[i]["g_address"].address
                  ? this.tro_list[i]["g_address"].address + ","
                  : "";
                strAddress += this.tro_list[i]["g_address"].rsrvstr2
                  ? this.tro_list[i]["g_address"].rsrvstr2
                  : "";
              } else {
                strAddress += this.userinfo.province
                  ? this.userinfo.province + ","
                  : "";
                strAddress += this.userinfo.city
                  ? this.userinfo.city + ","
                  : "";
                strAddress += this.userinfo.area
                  ? this.userinfo.area + ","
                  : "";
                strAddress += this.userinfo.address
                  ? this.userinfo.address + ","
                  : "";
                strAddress += this.userinfo.company
                  ? this.userinfo.company
                  : "";
              }
            }

            const result = await req_orderCreate(
              this.userinfo.userid,
              this.tro_list[i].bid,
              this.tro_list[i].uploadedfilename,
              this.tro_list[i].uploadedfilepath,
              this.userinfo.company,
              this.tro_list[i]["g_address"].rsrvstr3 === "默认"
                ? this.tro_list[i].wlfs
                  ? "代发-" + this.tro_list[i].wlfs
                  : this.userinfo.loginip
                : this.tro_list[i]["g_address"].rsrvstr3 +
                    this.tro_list[i]["g_address"].kuaidigongsi,
              this.tro_list[i]["g_address"].rsrvstr1,
              this.tro_list[i]["g_address"].rsrvstr4,
              strAddress,
              gRemark,
              this.tro_list[i]["fbPrice"]
                ? this.tro_list[i]["fbPrice"]
                : this.tro_list[i].offerInfoPrice + this.tro_list[i].kuaidifei,
              wuliu,
              payment,
              this.tro_list[i].uploadedfilesize,
              this.tro_list[i].offerInfoString,
              this.tro_list[i].kuaidifei
            );
            //提交失败-添加索引到failArr;
            if (!result.success) {
              failArr.push(i);
            }
          }
          this.$parent.loadingChange(false);

          // 更新缓存用户信息
          this.$parent.func_appUpdateUserinfo();
          if (failArr.length < 1) {
            this.$parent.confirmChange(
              "success",
              "订单下单成功",
              () => {
                this.STORAGE.set("g_trollerList", []);
                this.$parent.func_tabbar_trolley();
                if (!this.isRoute) {
                  this.isRoute = true;
                  this.$router.push({
                    name: "orderManege",
                  });
                }
              },
              () => {},
              { yes: "查看我的订单", no: "" }
            );
            setTimeout(() => {
              if (!this.isRoute) {
                this.isRoute = true;
                this.STORAGE.set("g_trollerList", []);
                this.$parent.func_tabbar_trolley();
                this.$router.push({
                  name: "orderManege",
                });
              }
            }, 3000);
          } else {
            this.$parent.confirmChange(
              "success",
              "订单下单成功，" +
                failArr.length +
                "条订单提交失败，已退回购物车",
              () => {
                let arr = [];
                for (let i in failArr) {
                  arr.push(this.tro_list[failArr[i]]);
                }
                this.STORAGE.set("g_trollerList", arr);
                this.$router.push({
                  name: "orderManege",
                });
              },
              () => {},
              { yes: "查看我的订单", no: "" }
            );
          }

          this.func_init();
        } else {
          this.$parent.msgChange("fail", "可支配金额不足以支付订单", "");
        }
      } else if (payment === "1") {
        /* 在线支付 */
        const finalSumPrice = parseFloat(this.total_price);

        //循环订单列表-提交订单
        let failArr = []; //提交失败的订单
        let oidArr = ""; //所有订单id
        this.$parent.loadingChange(true, "提交订单中");
        for (let i in this.tro_list) {
          let gRemark = this.tro_list[i].remark ? this.tro_list[i].remark : "";
          let strAddress = "";
          if (this.tro_list[i]["g_address"]) {
            if (
              this.tro_list[i]["g_address"].rsrvstr3 === "快递" ||
              this.tro_list[i]["g_address"].rsrvstr3.indexOf("物流") >= 0 ||
              this.tro_list[i]["g_address"].rsrvstr3 === "代发快递" ||
              this.tro_list[i]["g_address"].rsrvstr3 === "代发物流"
            ) {
              strAddress += this.tro_list[i]["g_address"].province
                ? this.tro_list[i]["g_address"].province + ","
                : "";
              strAddress += this.tro_list[i]["g_address"].city
                ? this.tro_list[i]["g_address"].city + ","
                : "";
              strAddress += this.tro_list[i]["g_address"].area
                ? this.tro_list[i]["g_address"].area + ","
                : "";
              strAddress += this.tro_list[i]["g_address"].address
                ? this.tro_list[i]["g_address"].address + ","
                : "";
              strAddress += this.tro_list[i]["g_address"].rsrvstr2
                ? this.tro_list[i]["g_address"].rsrvstr2
                : "";
            } else {
              strAddress += this.userinfo.province
                ? this.userinfo.province + ","
                : "";
              strAddress += this.userinfo.city ? this.userinfo.city + "," : "";
              strAddress += this.userinfo.area ? this.userinfo.area + "," : "";
              strAddress += this.userinfo.address
                ? this.userinfo.address + ","
                : "";
              strAddress += this.userinfo.company ? this.userinfo.company : "";
            }
          }
          console.log(
            "aaaa=",
            this.userinfo.company,
            "bbbb=",
            this.tro_list[i]["g_address"].rsrvstr3 === "默认"
              ? this.tro_list[i].wlfs
                ? "代发-" + this.tro_list[i].wlfs
                : this.userinfo.loginip
              : this.tro_list[i]["g_address"].rsrvstr3 +
                  this.tro_list[i]["g_address"].kuaidigongsi,
            "cccc=",
            this.tro_list[i]["g_address"].rsrvstr1,
            "ddddd=",
            this.tro_list[i]["g_address"].rsrvstr4,
            "eeeee=",
            strAddress
          );
          const result = await req_orderCreate(
            this.userinfo.userid,
            this.tro_list[i].bid,
            this.tro_list[i].uploadedfilename,
            this.tro_list[i].uploadedfilepath,
            this.userinfo.company,
            this.tro_list[i]["g_address"].rsrvstr3 === "默认"
              ? this.tro_list[i].wlfs
                ? "代发-" + this.tro_list[i].wlfs
                : this.userinfo.loginip
              : this.tro_list[i]["g_address"].rsrvstr3 +
                  this.tro_list[i]["g_address"].kuaidigongsi,
            this.tro_list[i]["g_address"].rsrvstr1,
            this.tro_list[i]["g_address"].rsrvstr4,
            strAddress,
            gRemark,
            this.tro_list[i]["fbPrice"]
              ? this.tro_list[i]["fbPrice"]
              : this.tro_list[i].offerInfoPrice + this.tro_list[i].kuaidifei,
            wuliu,
            payment,
            this.tro_list[i].uploadedfilesize,
            this.tro_list[i].offerInfoString,
            this.tro_list[i].kuaidifei
          );
          //提交失败-添加索引到failArr;
          if (!result.success) {
            failArr.push(i);
          } else {
            if (oidArr === "") {
              oidArr += result.data;
            } else {
              oidArr += "," + result.data;
            }
          }
        }
        this.$parent.loadingChange(false);
        // 更新缓存用户信息
        this.$parent.func_appUpdateUserinfo();
        if (failArr.length < 1) {
          this.$parent.confirmChange(
            "success",
            "注意：您的订单尚未下单成功，扫码支付后订单才会安排下单生产，如未支付，由此产生的货期问题由客户自行承担。",
            () => {
              this.STORAGE.set("g_trollerList", []);
              //缓存onlinePay参数
              this.STORAGE.set("g_orderInfoEd", {
                orderId: oidArr,
                total: finalSumPrice,
              });
              this.$router.push({
                name: "onlinePay",
              });
              this.func_init();
            },
            () => {},
            { yes: "去支付", no: "" }
          );
        } else {
          this.$parent.confirmChange(
            "success",
            "注意：您的订单尚未下单成功，扫码支付后订单才会安排下单生产，如未支付，由此产生的货期问题由客户自行承担。 【" +
              failArr.length +
              "条订单提交失败，已退回购物车】",
            () => {
              let arr = [];
              for (let i in failArr) {
                arr.push(this.tro_list[failArr[i]]);
              }
              this.STORAGE.set("g_trollerList", arr);
              //缓存onlinePay参数
              this.STORAGE.set("g_orderInfoEd", {
                orderId: oidArr,
                total: finalSumPrice,
              });
              this.$router.push({
                name: "orderManege",
              });
              this.func_init();
            },
            () => {},
            { yes: "去支付", no: "" }
          );
        }
      }
    },
    async func_init() {
      this.$parent.loadingChange(true);
      await this.func_userAddressList();
      await this.func_trolleyList();
      await this.func_userDeposit();
      this.$parent.loadingChange(false);
    },
  },
  mounted() {
    const userinfo = this.STORAGE.get("g_userInfo");
    console.log(userinfo);
    if (userinfo && userinfo["userid"]) {
      this.userinfo = userinfo;
      this.func_init();
    }
  },
};
</script>
<style src='@/style/trolley.css' scoped></style>



// WEBPACK FOOTER //
// src/pages/Trolley.vue